import { useLocalStorage } from '@mantine/hooks';

import { useActiveUserQuery } from '../../../../shared/hooks/useActiveUserQuery.hook';

export function useOpenedSections() {
  const activeUserQuery = useActiveUserQuery();

  const activeWorkspaceId = activeUserQuery.data?.user.activeWorkspace?.id;

  const [openedSections, setOpenedSections] = useLocalStorage<string[]>({
    key: `openedSections-${activeWorkspaceId}`,
    defaultValue: [],
  });

  return {
    openedSections,
    setOpenedSections,
  };
}
